import es from '../../translation/es_ES'

export default {
  // i18nConfiguration
  i18n: {
    locales: [
      {
        code: 'es',
        iso: 'es-ES',
      },
    ],
    defaultLocale: 'es',
    vueI18n: {
      fallbackLocale: 'es',
      messages: {
        es,
      },
    },
    pages: {
      'categories/inspirations': {
        es: '/inspiracion',
      },
      'categories/gifts': {
        es: '/regalos',
      },
      'categories/occasions': {
        es: '/ocasiones',
      },
      'categories/tutorials-and-advices': {
        es: '/tutoriales-y-consejos',
      },
      'categories/home-furnishing': {
        es: '/decoracion-de-casa',
      },
      'editorial-staff/index': {
        es: '/redazione',
      },
      'editorial-staff/_author': {
        es: '/redazione/:author?',
      },
    },
  },
  /* 
    Categories Configuration
    @order: [] è l'array delle chiavi delle categorie e rappresenta l'ordine con cui verranno visualizzate le categorie dove richieste
    list{
        @key è la chiave della categoria. Per convenzione chiamata come il folder dentro page.
        {
          @slug è lo slug della categoria inserito in categorie su Wordpress
          @view è la view di nuxt e corrisponde al name utilizzato nei nuxt-link
        }
    }
  */
  pages: {
    // leggere README.md
    list: [
      {
        key: 'index', // Home per comodità la trattiamo come una categoria
        wpUri: '/?page_id=232',
      },
      {
        key: 'inspirations',
        wpUri: '/?page_id=236',
      },
      {
        key: 'gifts',
        wpUri: '/?page_id=238',
      },
      {
        key: 'occasions',
        wpUri: '/?page_id=234',
      },
      {
        key: 'tutorials-and-advices',
        wpUri: '/?page_id=242',
      },
      {
        key: 'home-furnishing',
        wpUri: '/?page_id=240',
      },
      {
        key: 'editorial-staff',
        wpUri: '/redazione/',
      },
    ],
  },
  categories: {
    // leggere README.md
    list: [
      {
        key: 'inspirations',
        wpSlug: 'inspirations',
        view: 'categories-inspirations',
        wpCategoryId: 5,
      },
      {
        key: 'gifts',
        wpSlug: 'gifts',
        view: 'categories-gifts',
        wpCategoryId: 6,
      },
      {
        key: 'occasions',
        wpSlug: 'occasions',
        view: 'categories-occasions',
        wpCategoryId: 4,
      },
      {
        key: 'tutorials-and-advices',
        wpSlug: 'tutorials-and-advices',
        view: 'categories-tutorials-and-advices',
        wpCategoryId: 7,
      },
      {
        key: 'home-furnishing',
        wpSlug: 'home-furnishing',
        view: 'categories-home-furnishing',
        wpCategoryId: 8,
      },
      {
        key: 'highlights',
        wpSlug: 'highlights',
        view: null,
        wpCategoryId: 3,
      },
    ],
  },
  giftaWebsite: 'https://www.gifta.es/',
  navigation: {
    primary: {
      order: [
        'inspirations',
        'gifts',
        'occasions',
        'tutorials-and-advices',
        'home-furnishing',
      ],
    },
    // Categorie che vengono filtrate da eventuali elenchi (es. la lista delle categorie a cui appartiene un post)
    exclude: ['highlights'],
  },
  social: [
    {
      key: 'facebook',
      url: 'https://www.facebook.com/Giftaes-102748558333081',
    },
    {
      key: 'instagram',
      url: 'https://www.instagram.com/gifta.es/?hl=it',
    },
  ],
  terms: [
    {
      key: 'privacy-policy',
      url: 'https://www.gifta.es/privacy-policy/',
    },
    {
      key: 'cookie-policy',
      url: 'https://www.gifta.es/cookie/',
    },
    {
      key: 'informazioni-legali',
      url: 'https://www.gifta.es/informaciones-legales/',
    },
  ],
  pixaLinks: [
    {
      key: 'books-magazines',
      url: 'https://www.pixartprinting.es/impresion-revistas-catalogos-libros/',
    },
    {
      key: 'business-cards',
      url: 'https://www.pixartprinting.es/tarjetas-de-visita/',
    },
    {
      key: 'flyers',
      url: 'https://www.pixartprinting.es/formato-pequeno/impresion-folletos-flyers/',
    },
  ],
  shopLinks: [
    {
      label: 'Regalos personalizados',
      url: 'https://www.gifta.es/regalos-personalizados/',
    },
    {
      label: 'Foto en lienzo',
      url: 'https://www.gifta.es/foto-en-lienzo/',
    },
    {
      label: 'Lienzos personalizados',
      url: 'https://www.gifta.es/foto-en-lienzo/lienzos-personalizados/',
    },
    {
      label: 'Decoración de pared',
      url: 'https://www.gifta.es/foto-decoracion/',
    },
    {
      label: 'Fotorregalos',
      url: 'https://www.gifta.es/foto-regalos/',
    },
    {
      label: 'Cojines personalizados',
      url: 'https://www.gifta.es/foto-regalos/cojines-personalizados/',
    },
    {
      label: 'Tazas personalizadas',
      url: 'https://www.gifta.es/foto-regalos/tazas-personalizadas/',
    },
    {
      label: 'Bolsas personalizadas',
      url: 'https://www.gifta.es/foto-regalos/bolsas-shopper-personalizadas/',
    },
    {
      label: 'Camisetas personalizadas',
      url: 'https://www.gifta.es/camisetas-personalizadas/',
    },
    {
      label: 'Fotolibros',
      url: 'https://www.gifta.es/libros-de-fotos/',
    },
    {
      label: 'Calendarios personalizados',
      url: 'https://www.gifta.es/calendarios-personalizados/',
    },
    {
      label: 'Ideas de regalo',
      url: 'https://www.gifta.es/ideas-de-regalo/',
    },
  ],
  nuxtConfiguration: {
    head: {
      script: [
        {
          src: 'https://21fd768e7ea04855a8a850bd8ab542cf.js.ubembed.com',
          async: true,
        },
      ],
    },
  },
}
